import { createMap, addBoundaryLayer, addHydrantLayer, fitToHydrants, onHydrantClick } from "./map.ts";
import { loadHydrants } from "./hydrants.ts";
import { loadBoundaries } from "./boundaries.ts";
import { mountAuthUI, onAuthChange } from "./auth.ts";
import { mountSidebar } from "./sidebar.ts";
import type { Hydrant } from "./types.ts";

const mapEl = document.getElementById("map") as HTMLElement;
const authSlot = document.getElementById("auth-slot") as HTMLElement;
const sidebar = document.getElementById("sidebar") as HTMLElement;
const sidebarContent = document.getElementById("sidebar-content") as HTMLElement;
const sidebarClose = document.getElementById("sidebar-close") as HTMLButtonElement;
const loginHint = renderLoginHint();
mapEl.append(loginHint);

mountAuthUI(authSlot);

const map = createMap(mapEl);
const showSidebar = mountSidebar(sidebar, sidebarContent, sidebarClose, (id) => byId.get(id));

let byId = new Map<string, Hydrant>();
let hasFitted = false;

async function refresh(): Promise<void> {
  try {
    const { hydrants, features } = await loadHydrants();
    byId = new Map(hydrants.map((h) => [h.id, h]));
    loginHint.hidden = hydrants.length > 0;
    if (map.isStyleLoaded()) addHydrantLayer(map, features);
    else map.once("load", () => addHydrantLayer(map, features));
    // Beim ersten Laden mit Daten den Ausschnitt auf die Gemeinde einpassen.
    if (!hasFitted && hydrants.length > 0) {
      hasFitted = true;
      fitToHydrants(map, features);
    }
  } catch (err) {
    console.error("Hydranten laden fehlgeschlagen:", err);
  }

  try {
    const boundaries = await loadBoundaries();
    if (boundaries.features.length === 0) return;
    if (map.isStyleLoaded()) addBoundaryLayer(map, boundaries);
    else map.once("load", () => addBoundaryLayer(map, boundaries));
  } catch (err) {
    console.error("Gemeindegrenze laden fehlgeschlagen:", err);
  }
}

onHydrantClick(map, (id) => {
  const h = byId.get(id);
  if (h) showSidebar(h);
});

// Neu laden sobald sich der Login-Status ändert (damit Daten nach Magic-Link auftauchen).
let lastUserId: string | null | undefined;
onAuthChange((session) => {
  const uid = session?.user.id ?? null;
  if (uid === lastUserId) return;
  lastUserId = uid;
  void refresh();
});

function renderLoginHint(): HTMLElement {
  const el = document.createElement("div");
  el.id = "login-hint";
  el.innerHTML =
    '<strong>Nicht eingeloggt.</strong> ' +
    "Bitte oben rechts mit deiner E-Mail anmelden, dann erscheinen die Hydranten der Gemeinde.";
  el.hidden = false;
  return el;
}
